import { faker } from '@faker-js/faker'

import { getAdminServiceOfferDetails } from './AdminServiceOfferDetails'

import { asBuilder } from '../asBuilder'
import { PartnerServiceOfferDraft } from '../../contracts/service-offer'

export const getPartnerServiceOfferDraft = asBuilder((): PartnerServiceOfferDraft => {
  const fixture = getAdminServiceOfferDetails()
  const { groupId, groupedServiceOffers, ...content } = fixture
  return {
    id: faker.string.uuid(),
    storedAtUtc: faker.date.recent().toUTCString(),
    content,
  }
})
